import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./Assets/css/bootstrap.css"
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import configStore from './Redux/Store';
import {persistStore} from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

const store = configStore()
const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
